<template>
  <div
    class="cell"
    :class="{ selected: selected }"
    @click="$emit('onCellClicked', text)"
  >
    <span class="select-none">{{ text }}</span>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: null,
      required: false
    },
    selected: {
      type: Boolean,
      default: false,
      required: false
    }
  }
};
</script>

<style lang="postcss" scoped>
.cell {
  @apply transition transform duration-150 ease-in-out py-2 rounded-md bg-gray-200 text-xs leading-3 font-medium text-gray-600 mt-2 flex items-center justify-center cursor-pointer select-none;
  &:hover {
    @apply bg-gray-300 text-gray-700;
  }
  &:focus {
    @apply outline-none shadow-none transform scale-95;
  }
  &:active {
    @apply outline-none shadow-none transform scale-95;
  }

  &.selected {
    @apply bg-green-200 text-green-600;

    &:hover {
      @apply bg-green-300 text-green-700;
    }
  }
}
</style>
